__turbopack_context__.v({
  "listingsDetailedInfinityScroll_loader": "listing-detailed-infinity-loader-module-scss-module__Rsa6uG__listingsDetailedInfinityScroll_loader",
});
